// Axios API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// React
import { useEffect, useState } from 'react'

// Mantine
import { Anchor, Button } from '@mantine/core'

// Next
import RouterLink from '@/components/ui/RouterLink'

// Dayjs
import dayjs from 'dayjs'

// Status
import { getEstimateStatus } from '@/lib/retailerStatuses'

// UI
import Badge from '@/components/ui/Badge'
import Box from '@/components/ui/Box'

export default function RetailerSmallEstimateTable({ retailer_id }) {
    // Axios API
    const { requestGet, loading } = useAxiosApi()

    // Table data
    const [tableData, setTableData] = useState(null)

    // Load table data
    const loadTableData = async () => {
        const { data } = await requestGet(
            `/retailer-estimates?filters[retailer_id][0]=${retailer_id}&per_page=5`
        )

        setTableData(data)
    }

    useEffect(() => {
        if (retailer_id) {
            loadTableData()
        }
    }, [retailer_id])

    const rightSection = (
        <Anchor
            size="sm"
            variant="default"
            href={`/retailer_estimates?retailer_id=${retailer_id}`}
        >
            Tous les devis ({tableData?.total})
        </Anchor>
    )

    return (
        <Box title="Dernier devis" rightSection={rightSection}>
            {tableData?.data.length > 0 && (
                <div className="flex flex-col divide-y mt-5">
                    <div className="grid grid-cols-[1fr_150px_150px] w-full text-sm py-2">
                        <span>Numéro</span>
                        <span>Montant</span>
                        <span>Statut</span>
                    </div>

                    {tableData.data.map((estimate) => (
                        <div
                            key={estimate.id}
                            className="grid grid-cols-[1fr_150px_150px] w-full text-gray-500 py-2 items-center"
                        >
                            <div className="flex flex-col gap-1 items-start">
                                <Anchor
                                    href={`/retailer_estimates/${estimate.id}`}
                                >
                                    {estimate.number}
                                </Anchor>
                                <span>{dayjs(estimate.date).format('ll')}</span>
                            </div>

                            <span>{estimate.amounts.total} €</span>

                            <Badge
                                color={
                                    getEstimateStatus(estimate.status)
                                        .badgeColor
                                }
                            >
                                {getEstimateStatus(estimate.status).label}
                            </Badge>
                        </div>
                    ))}
                </div>
            )}

            {tableData?.data.length === 0 && (
                <span className="text-sm text-gray-500 my-5 text-center">
                    Aucun devis pour le moment
                </span>
            )}

            <div className="mt-5 flex justify-center">
                <Button
                    component={RouterLink}
                    href={`/retailer_estimates/create?retailer_id=${retailer_id}`}
                >
                    Créer un devis
                </Button>
            </div>
        </Box>
    )
}
